export default "__VITE_ASSET__CYQz0Lw1__"